/** Read effective setup field values from customer_setup (mirrors backend readFieldValues). */

const PLATFORM_INSTANCE_NAME_KEY = 'instance_display_name';
const PLATFORM_INSTANCE_LOCATION_KEY = 'instance_location';
const SCHEDULING_WORKING_SET_KEY = 'scheduling_working_set';

function asObject(value: unknown): Record<string, unknown> {
  if (value && typeof value === 'object' && !Array.isArray(value)) {
    return value as Record<string, unknown>;
  }
  return {};
}

export function readSetupFieldValues(setup: Record<string, unknown>): Record<string, unknown> {
  const fields = asObject(setup['fields']);
  const values: Record<string, unknown> = { ...fields };

  const site = asObject(setup['site']);
  if (typeof site['name'] === 'string' && site['name'].trim()) {
    values[PLATFORM_INSTANCE_NAME_KEY] = site['name'].trim();
  }
  if (typeof site['location'] === 'string' && site['location'].trim()) {
    values[PLATFORM_INSTANCE_LOCATION_KEY] = site['location'].trim();
  }
  if (setup['scheduling_working_set'] !== undefined && setup['scheduling_working_set'] !== null) {
    values[SCHEDULING_WORKING_SET_KEY] = setup['scheduling_working_set'];
  }

  return values;
}

export function hasSetupFieldValue(
  type: string,
  key: string,
  value: unknown
): boolean {
  if (type === 'boolean') {
    return typeof value === 'boolean';
  }
  if (type === 'file' || key === SCHEDULING_WORKING_SET_KEY) {
    if (!value || typeof value !== 'object') return false;
    const ws = value as Record<string, unknown>;
    const resources = ws['resources'];
    return Array.isArray(resources) && resources.length > 0;
  }
  if (type === 'number') {
    return typeof value === 'number' && !Number.isNaN(value);
  }
  if (typeof value === 'string') {
    return value.trim().length > 0;
  }
  if (value !== undefined && value !== null) {
    if (typeof value === 'object') {
      return Object.keys(value as object).length > 0;
    }
    return true;
  }
  return false;
}
